jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

 
length = 2500;
cHtml = $(".custom_txt .cotant_div").html();
cText = $(".custom_txt .cotant_div").text().substr(0, length).trim();
$(".custom_txt .cotant_div").addClass("compressed").html(cText + "... <a href='#' class='exp'>Read More</a>");
window.handler = function()
{
        $('.exp').click(function(){
            if ($(".custom_txt .cotant_div").hasClass("compressed"))
            {
                $(".custom_txt .cotant_div").html(cHtml + "<a href='#' class='exp'>Read Less</a>");
                $(".custom_txt .cotant_div").removeClass("compressed");
                handler();
                return false;
            }
            else
            {
                $(".custom_txt .cotant_div").html(cText + "... <a href='#' class='exp'>Read More</a>");
                $(".custom_txt .cotant_div").addClass("compressed");
                handler();
                return false;
            }
        });
}
handler();  
});


